/** @type {Record<import("utils/types").EcommPlatformSource, string>} */
export const STORE_URL_PREFIX = {
  SHOPIFY: 'https://',
  BIGCOMMERCE: 'https://',
  WOOCOMMERCE: ''
};

/** @type {Record<import("utils/types").EcommPlatformSource, string>} */
export const STORE_URL_SUFFIX = {
  SHOPIFY: '.myshopify.com',
  BIGCOMMERCE: '.mybigcommerce.com',
  WOOCOMMERCE: ''
};
